(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-logo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const state = window.onhowScrollingLogos = window.onhowScrollingLogos || {
    resizeTimer: null
  };

  function initAllSections() {
    document.querySelectorAll('.onhow-scrolling-logos-section').forEach(section => {
      const scrollingEnabled = section.getAttribute('data-scrolling-enabled') === 'true';
      if (!scrollingEnabled) return;
      initScrollSection(section);
    });
  }

  async function initScrollSection(section) {
    const track = section.querySelector('.onhow-scrolling-logos-track');
    if (!track) return;

    track.classList.remove('onhow-initialized');

    const inner1 = track.querySelector('.onhow-scrolling-logos-inner--1');
    const inner2 = track.querySelector('.onhow-scrolling-logos-inner--2');
    if (!inner1 || !inner2) return;

    inner1.style.animation = 'none';
    inner2.style.display = 'none';

    await preloadImages(track);
    setupTrack(section, track, inner1);
  }

  function preloadImages(track) {
    return new Promise(resolve => {
      const imgs = [...track.querySelectorAll('img')].filter(img => !img.complete);
      if (!imgs.length) return resolve();
      let remaining = imgs.length;
      const done = () => { if (--remaining === 0) resolve(); };
      imgs.forEach(img => {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
    });
  }

  function setupTrack(section, track, inner1) {
    // Get original items — use data-original store to survive re-inits
    let originals = section._originalItems;
    if (!originals) {
      originals = [...inner1.querySelectorAll('.onhow-logo-item')].map(el => el.cloneNode(true));
      section._originalItems = originals;
    }

    if (!originals.length) return;

    // Read gap from CSS variable / computed style on the track container
    const logoSpacing = parseInt(
      getComputedStyle(track.closest('.onhow-scrolling-logos-section'))
        .getPropertyValue('--logo-spacing')
    ) || parseFloat(getComputedStyle(inner1).gap) || 30;

    const containerWidth = track.offsetWidth;
    const baseSpeed = parseFloat(section.getAttribute('data-scroll-speed')) || 60;

    // --- Measure one set off-screen ---
    const measurer = document.createElement('div');
    measurer.style.cssText = `
      position: fixed;
      top: -9999px;
      left: -9999px;
      display: flex;
      gap: ${logoSpacing}px;
      width: max-content;
      visibility: hidden;
      pointer-events: none;
    `;
    originals.forEach(item => measurer.appendChild(item.cloneNode(true)));
    document.body.appendChild(measurer);
    const oneSetWidth = measurer.scrollWidth;
    document.body.removeChild(measurer);

    if (oneSetWidth === 0) return;

    // How many sets to fill at least 2x the container width
    const setsNeeded = Math.max(2, Math.ceil((containerWidth * 2) / oneSetWidth) + 1);
    const totalSets = setsNeeded * 2;
    const halfWidth = oneSetWidth * setsNeeded;
    const pixelsPerSecond = oneSetWidth / baseSpeed;
    const duration = halfWidth / pixelsPerSecond;

    // Build the strip
    inner1.innerHTML = '';
    inner1.style.cssText = `
      display: flex;
      gap: ${logoSpacing}px;
      position: absolute;
      left: 0;
      top: 0;
      width: max-content;
      will-change: transform;
    `;

    for (let i = 0; i < totalSets; i++) {
      originals.forEach(item => inner1.appendChild(item.cloneNode(true)));
    }

    // Unique keyframe per section
    const sectionId = section.id || `sl-${Math.random().toString(36).substr(2, 6)}`;
    section.id = sectionId;
    const animName = `onhow-loop-${sectionId}`;

    let styleEl = document.getElementById(`style-${animName}`);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = `style-${animName}`;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = `
      @keyframes ${animName} {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-${halfWidth}px); }
      }
    `;

    // Start animation, then reveal — no flash
    inner1.style.animation = `${animName} ${duration}s linear infinite`;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        track.classList.add('onhow-initialized');
      });
    });
  }

  function handleResize() {
    clearTimeout(state.resizeTimer);
    state.resizeTimer = setTimeout(() => {
      document.querySelectorAll('.onhow-scrolling-logos-section').forEach(section => {
        const scrollingEnabled = section.getAttribute('data-scrolling-enabled') === 'true';
        if (!scrollingEnabled) return;
        initScrollSection(section);
      });
    }, 400);
  }

  initAllSections();
  window.addEventListener('resize', handleResize);
});

  } catch(e) { console.error(e); }
})();
})();
